import {
  Calendar,
  ColorTags,
  EventsIconMenu,
  GroupsIconClient,
  Notes,
  Person,
  PhoneClientProfile,
  VideosIcon,
} from '@shared/assets';

interface Props {
  moduleType:
    | 'profile'
    | 'programs'
    | 'events'
    | 'schedule'
    | 'notes'
    | 'groups'
    | 'colorTags'
    | string;
  hasLibrary?: boolean;
  alt: string;
}

export const TabsItemIcon: React.FC<Props> = ({ moduleType, alt, hasLibrary }) => {
  const getTabIcon = () => {
    switch (moduleType) {
      case 'profile':
        return <Person />;
      // Контакты
      case 'contacts':
        return <PhoneClientProfile />;
      // Заметки
      case 'notes':
        return <Notes />;

      // Консультации
      case 'schedule':
        return <EventsIconMenu />;

      // События
      case 'events':
        if (!hasLibrary) return <Calendar />;

      // Программы и видео
      case 'programs':
        return <VideosIcon />;

      case 'groups':
        return <GroupsIconClient />;

      case 'colorTags':
        return <ColorTags />;
    }
    return <div>{alt}</div>;
  };

  return <>{getTabIcon()}</>;
};
